import {BasicCriteria} from '../../../../allkey/framework/parameters/BasicCriteria';

export class MetaProcessCriteria extends BasicCriteria {
visionCode: string;
}

